import React, { Fragment, useEffect } from 'react';
import { Col, Row } from "react-bootstrap";
import { CaseFormField } from "../CaseGenerator";
import { useSelector } from "react-redux";
import { useFormikContext } from "formik";
import { SwitchUser } from '../../../helpers/helpers';
import {TranslatedText} from "../../../helpers/helpers";

const CombinedConditions = (props) => {
  const {layout, fields} = props;
  const {fields: layoutFields} = layout;
  const {values,setFieldValue} = useFormikContext();
  const user = useSelector((state) => state.auth);

  // contains true or false if a user was found or not
  const {userFetched} = user;

  // returns actual profile or the impersenation profile field from the user object
  const userProfile = SwitchUser(user);

  // get the user role of type UserRoleEnum
  const role = userProfile.role;
  useEffect(() => {
    setFieldValue('userRole', role)
  }, [role, setFieldValue])

  const isConditionMet = (conditionProps,alternativeCondition) => {
    if (!conditionProps || !alternativeCondition) {
      return true;
    }
    const conditions = conditionProps;

    if (conditions.length === 0 || alternativeCondition.length === 0) {
      return true;
    }
    let test = false;
    alternativeCondition.forEach(condition => {
      if (values[condition.if] === condition.is) {
        test = true;
      }});

    let allowed = false;
    conditions.forEach(condition => {
      if (userFetched && (role === condition.is)) {
        allowed = true;
      }
    });
    let show = false;
    if(alternativeCondition.length !== 0) {
      if(allowed && test) {
        show = true
      }
    } else {
      show = true;
    }

    return show;
  };

  return (
    <Fragment key={layout.title}>
      {!layout.noMandatoryLegend && (
        <p className={"case-step-mandatory-fields-legend paragraph-small-fs9"}><TranslatedText i18nKey="mandatory.fields.legend"/></p>
      )}
      {layout.title && <h2 className={'case-step-title'}>{layout.title}</h2>}
      {layout.description && <p className={'case-step-description'}>{layout.description}</p>}
      <Row>
        {
          layoutFields && layoutFields.map((item, index) => {
            const gridProps = item.grid;
            const conditionProps = item.condition || null;
            const alternativeCondition = item.alternativeCondition || null;
            const fieldProps = fields[item.fieldName];
            const conditionMet = isConditionMet(conditionProps,alternativeCondition);
            return conditionMet && (
              <Col {...gridProps} key={index}>
                {!item.fieldName && <h3 className="form-section-title">{item.text}</h3>}
                {item.fieldName && <CaseFormField {...fieldProps} />}
              </Col>
            )
          })
        }
        {
          layout.content && <div className="col-12">
            <div className={'content'}>{layout.content}</div>
          </div>
        }
      </Row>
    </Fragment>
  );
};



export default CombinedConditions;
